import { type membershipApi } from 'app/src/services/welfareportal'

export async function initStyles(frontendConfiguration?: membershipApi.FrontendConfiguration) {
  await fetchStyle(frontendConfiguration?.cssPath ?? 'css/fallback.css', true)
}

export async function updateStyles(frontendConfiguration?: membershipApi.FrontendConfiguration) {
  // Rimuovi il vecchio CSS del template
  const oldLinks = document.querySelectorAll('link[data-template-css="true"]')
  oldLinks.forEach((link) => {
    link.remove()
  })

  // Carica il nuovo CSS
  const newCssPath = frontendConfiguration?.cssPath ?? 'css/fallback.css'
  await fetchStyle(newCssPath, true)
}

const fetchStyle = async (url: string, markAsTemplate = false) => {
  return new Promise<void>((resolve, reject) => {
    const link = document.createElement('link')
    link.type = 'text/css'
    link.rel = 'stylesheet'
    if (markAsTemplate) {
      link.dataset.templateCss = 'true'
    }
    link.href = url
    link.onload = () => resolve()
    link.onerror = () => reject()

    const headScript = document.querySelector('head')
    headScript!.appendChild(link)
  })
}
